module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/doctors/noimage_s120x120-d2f8ba83faf32f33863ab5db7a5e4cd6.jpg";